// extracted by mini-css-extract-plugin
module.exports = {"SubmittedSelections":"SubmittedSelections_SubmittedSelections__1OzB5"};